<template>
  <div id="visitRepair" class="clearfix" v-loading.fullscreen.lock="loading">
    <el-col class="clearfix searthPart">
      <div class="clearfix container">
        <p class="headerT fl" style="width: 80px;margin-top:0;">工单信息</p>
        <el-button class="fl" size="small" type="danger" style="margin: -5px 0 0 0px;"
          v-if="orderInfoForm.adminStatus == '20' || orderInfoForm.adminStatus == '04'">{{ orderInfoForm.adminStatus |
            sysCodeFileter('admin_status') }}</el-button>
        <el-button class="fl" size="small" type="success" style="margin: -5px 0 0 0px;" v-else>{{
          orderInfoForm.adminStatus | sysCodeFileter('admin_status') }}</el-button>
        <span class="fl" style="font-size:14px;margin-left:10px" v-if="orderInfoForm.adminStatus == '04'">(挂起原因：{{
          orderInfoForm.handUpReason |
          sysCodeFileter('hand_up_reason') }})</span>
        <span class="fl" style="font-size:14px;margin-left:10px" v-if="orderInfoForm.adminStatus == '20'">(取消原因：{{
          orderInfoForm.cancelReason |
          sysCodeFileter('order_cancel_reason') }} {{ orderInfoForm.cancelDesc }})</span>
        <el-button v-if="orderInfoForm.maintenanceResult" class="fl" size="small" type="danger"
          style="margin: -5px 0 0 10px;">{{ orderInfoForm.maintenanceResult |
            sysCodeFileter('maintenance_result') }}</el-button>
        <span class="fl" style="font-size:14px;margin-left:10px" v-if="orderInfoForm.maintenanceResult == '3'">(失败原因：{{
          orderInfoForm.repairFailureReason |
          sysCodeFileter('maintance_fail_reason') }} {{ orderInfoForm.repairFailureDesc }})</span>
        <i @click="setOrderTagOpe(orderInfoForm, orderInfoForm.isTag)" class="el-icon-star-off fl"
          style="font-size:20px;margin-left: 20px;margin-right:20px"
          :class="{ 'StarOn': orderInfoForm.isTag == 1 }"></i>
        <a v-if="orderInfoForm.attribute4 != null"
          :href='`https://m4.allscs.cn/n4web/detailInfo?id=${orderInfoForm.attribute4}&orderNo=${orderInfoForm.orderNo}`'
          download target='_blank'>查询维服</a>
        <el-button @click="addMaterials()" class="wuliao" size="small" type="success" style="margin: -5px 0 0 0px;"
          v-if="basicsAuth.addMaterials">添加物料</el-button>
        <el-col class="fr" :span="1">
          <i class="el-icon-refresh" style="font-size: 25px;cursor: pointer;" @click="refresh()"></i>
        </el-col>
      </div>
      <!-- 添加物料弹框 -->
      <el-dialog title="提示" :visible.sync="dialogVisible" width="50%">
        <el-form ref="formSearch" :inline="true" :model="formSearch">
          <el-form-item style="display: inline-block;" label="小码">
            <el-input v-model="formSearch.smallCode" clearable placeholder="请添加小码"></el-input>
          </el-form-item>
          <el-form-item style="display: inline-block;">
            <el-button type="primary" size="small" @click="onSubmit">添加</el-button>
          </el-form-item>
        </el-form>
        <el-table :data="tableData" border style="width:100%;">
          <el-table-column align="center" prop="materialCode" label="物料编码"></el-table-column>
          <el-table-column align="center" prop="materialName" label="物料名称"></el-table-column>
          <el-table-column align="center" prop="code" label="序列号（小码）"></el-table-column>
          <el-table-column align="center" prop label="操作">
            <template slot-scope="scope">
              <el-button @click.native.prevent="deleteRow(scope.$index, tableData)" type="text"
                size="small">移除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="confimAddMaterial">确 定</el-button>
        </span>
      </el-dialog>
      <el-form ref="orderInfoForm" :rules="rules" :model="orderInfoForm" label-width="80px"
        :label-position="labelPosition">
        <ul class="item-content">
          <li>
            <el-form-item label="工单编号">
              <el-input disabled v-model="orderInfoForm.orderNo" style="font-size:14px">
                <!-- <template
                  slot="append"
                  v-if="orderInfoForm.afterCount !== 0"
                >售后数:{{orderInfoForm.afterCount}}</template> -->
              </el-input>
            </el-form-item>
            <!-- <el-form-item
              v-if="orderInfoForm.afterCount !== 0"
              label="售后订单"
              v-for="(item ,index ) in orderInfoForm.afterOrder"
              :key="index"
            >
              <div
                class="fl"
                style="width: 85%;background-color: #f5f7fa;border-color: #e4e7ed;color: #c0c4cc;cursor: pointer;    border-radius: 4px;border: 1px solid #dcdfe6;padding-left: 10px;color: #3399FF;"
                @click="gotoService(item)"
              >{{item.orderNo}}</div>
            </el-form-item> -->
            <el-form-item v-if="orderInfoForm.originalOrderNo != null && orderInfoForm.originalOrderNo != ''"
              label="原始订单">
              <div class="fl"
                style="width: 85%;background-color: #f5f7fa;border-color: #e4e7ed;color: #c0c4cc;cursor: pointer;    border-radius: 4px;border: 1px solid #dcdfe6;padding-left: 10px;color: #3399FF;"
                @click="gotoOrigin(orderInfoForm)">{{ orderInfoForm.originalOrderNo }}</div>
            </el-form-item>
          </li>
          <li>
            <el-form-item label="工单类型">
              <el-select disabled v-model="orderInfoForm.serviceType" placeholder="请选择工单类型" style="width: 100%;">
                <el-option v-for="(item, index) in orderTypeList" :key="index" :label="item.paraName"
                  :value="item.paraValue"></el-option>
              </el-select>
            </el-form-item>
          </li>
          <li>
            <el-form-item label="渠道来源" required>
              <el-select filterable clearable v-model="orderInfoForm.orderIdentifier" placeholder="请选择渠道来源"
                :disabled="!basicsAuth.change_order_source" style="width: 100%;">
                <el-option v-for="(item, index) in sourceForList" :key="index" :label="item.paraName"
                  :value="item.paraValue"></el-option>
              </el-select>
            </el-form-item>
          </li>
          <li>
            <el-form-item label="渠道类型" prop="orderIdentifier">
              <el-select :disabled="true" v-model="orderInfoForm.channelType" filterable placeholder="请选择渠道类型">
                <el-option v-for="item, index in channelTypeList" :key="index" :label="item.paraName"
                  :value="item.paraValue">
                </el-option>
              </el-select>
            </el-form-item>
          </li>
          <li class="bookTime">
            <el-form-item label="预约时间" required>
              <el-date-picker style="width:31% ;font-size:14px" v-model="orderInfoForm.jOrderServiceEntity.onsiteDate"
                type="date" placeholder="选择日期"></el-date-picker>
              <el-time-select style="width:31% ; font-size:14px" placeholder="起始时间"
                v-model="orderInfoForm.jOrderServiceEntity.onsiteTimeStart" :picker-options="{
                  start: '9:00',
                  step: '01:00',
                  end: '22:00'
                }"></el-time-select>
              <el-time-select style="width:31% ; font-size:14px" placeholder="结束时间"
                v-model="orderInfoForm.jOrderServiceEntity.onsiteTimeEnd" :picker-options="{
                  start: '9:00',
                  step: '01:00',
                  end: '22:00',
                  minTime: orderInfoForm.jOrderServiceEntity.onsiteTimeStart
                }"></el-time-select>
            </el-form-item>
          </li>
        </ul>
        <ul class="item-content">
          <li>
            <el-form-item label="客户姓名" required>
              <el-input v-model.trim="orderInfoForm.clientBasicInformation.customerName" placeholder="请输入姓名（不超过30字）"
                :maxlength="30"></el-input>
            </el-form-item>
          </li>
          <li>
            <el-form-item label="联系电话" required>
              <el-input v-model.trim="orderInfoForm.clientBasicInformation.telephoneNo"
                onKeypress="return (/[\d]/.test(String.fromCharCode(event.keyCode)))" :maxlength="20"></el-input>
            </el-form-item>
          </li>
          <li class="location" v-if="orderInfoForm.serviceType != 'DD' && orderInfoForm.serviceType != 'DS'">
            <el-form-item label="地址" required class="clearfix">
              <el-form-item style="width: 15%;float:left">
                <el-select filterable prop="provinceId" placeholder="省" v-model="provinceId" @change="choseProvince">
                  <el-option v-for="(item, index) in provinceList" :label="item.name" :value="item.code"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item style="width: 15%;float:left">
                <el-select filterable v-model="cityId" value-key="id" @change="choseCity" placeholder="市">
                  <el-option v-for="(item, index) in cityList" :key="index" :label="item.name"
                    :value="item.code"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item style="width: 15%;float:left">
                <el-select filterable v-model="countyId" value-key="id" @change="choseCounty" placeholder="区">
                  <el-option v-for="(item, index) in countyList" :key="index" :label="item.name"
                    :value="item.code"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item style="width: 15%;float:left">
                <el-select filterable v-model="streetId" value-key="id" @change="choseStreet" placeholder="街道">
                  <el-option v-for="(item, index) in streetList" :key="index" :label="item.name"
                    :value="item.code"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item required style="width: 40%;float:left">
                <el-input style="width: 94%" v-model.trim="orderInfoForm.clientBasicInformation.address"
                  :maxlength="200" placeholder="请输入详细地址（不超过200字）"></el-input>
              </el-form-item>
            </el-form-item>
          </li>
          <li v-if="orderInfoForm.serviceType == 'DD' || orderInfoForm.serviceType == 'DS'">
            <el-form-item label="门店" required style="width: 100%;" label-width="50px">
              <el-select filterable @change="selectShop" v-model="orderInfoForm.jOrderServiceEntity.shopId"
                placeholder="请选择门店">
                <el-option v-for="item, index in shopDataList" :key="index" :label="item.name"
                  :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </li>
          <li
            v-if="(orderInfoForm.serviceType == 'DD' || orderInfoForm.serviceType == 'DS') && orderTypeStorage == '2' && orderInfoForm.adminStatus != '01'">
            <el-form-item label="工程师" style="width: 100%;" label-width="70px">
              <el-select filterable v-model="orderInfoForm.engineerId" placeholder="请选择门店工程师">
                <el-option v-for="item, index in engineerDataList" :key="index" :label="item.name"
                  :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </li>
        </ul>
        <ul class="item-content">
          <li class="memo">
            <el-form-item label="备注信息">
              <el-input v-model.trim="orderInfoForm.remark" style="width: 100%" :maxlength="400" type="text"
                placeholder="请输入备注信息（不超过400字）"></el-input>
            </el-form-item>
          </li>
        </ul>
        <div class="dashLine" v-if="orderInfoForm.orderCardInfo"></div>
        <div class="card-info" v-if="orderInfoForm.orderCardInfo">
          <div class="card-item">
            <div class="card-item-title">卡号: </div>
            <div class="card-item-content">{{ orderInfoForm.orderCardInfo.cardNo }}</div>
          </div>
          <div class="card-item">
            <div class="card-item-title">卡密: </div>
            <div class="card-item-content">{{ orderInfoForm.orderCardInfo.cardPwd }}</div>
          </div>
          <div class="card-item">
            <div class="card-item-title">说明: </div>
            <div class="card-item-content">{{ orderInfoForm.orderCardInfo.memo }}</div>
          </div>
        </div>

        <div class="dashLine" v-if="isDianShangBanDan">
          <p class="headerT">销售信息</p>
        </div>
        <ul class="item-content" style="padding-top: 20px;" v-if="isDianShangBanDan">
          <li>
            <el-form-item label="销售单号" prop="saleOrderNo">
              <el-input :disabled="true" clearable v-model.trim="orderInfoForm.saleOrderNo" type="text" maxlength="30"
                placeholder="请输入销售单号"></el-input>
            </el-form-item>
          </li>
          <li>
            <el-form-item label="商品SKU" prop="saleGoodsSku">
              <el-input :disabled="true" clearable v-model.trim="orderInfoForm.saleGoodsSku" type="text" maxlength="30"
                placeholder="请输入销售商户SKU"></el-input>
            </el-form-item>
          </li>
          <li>
            <el-form-item label="实收金额" prop="saleActualAmount">
              <el-input :disabled="true" clearable v-model.trim="orderInfoForm.saleActualAmount" type="text"
                maxlength="30" placeholder="请输入实收金额"></el-input>
            </el-form-item>
          </li>
        </ul>
        <div class="dashLine"></div>
        <ul class="item1-content">
          <li>
            <el-form-item label="品牌" prop="brandId" label-width="60px">
              <el-select filterable v-model="orderInfoForm.brandId" placeholder="请选择品牌" @change="choseBrand"
                style="display:block">
                <el-option v-for="(item, index) in brandList" :key="index" :label="item.brandName"
                  :value="item.brandId">{{
                    item.brandName }}</el-option>
              </el-select>
            </el-form-item>
          </li>
          <li>
            <el-form-item label="品类" prop="categoryId" label-width="60px">
              <el-select filterable v-model="orderInfoForm.categoryId" placeholder="请选择品类" @change="choseCategory"
                style="display:block">
                <el-option v-for="(item, index) in categoryList" :key="index" :label="item.categoryName"
                  :value="item.categoryId">{{ item.categoryName }}</el-option>
              </el-select>
            </el-form-item>
          </li>
          <li>
            <el-form-item label="型号" prop="modelId" label-width="60px">
              <el-select filterable v-model="orderInfoForm.modelId" placeholder="请选择型号" @change="choseModel"
                style="display:block">
                <el-option v-for="(item, index) in modelList" :key="index" :label="item.modelName"
                  :value="item.modelId">{{
                    item.modelName }}</el-option>
              </el-select>
            </el-form-item>
          </li>
          <li>
            <el-form-item label="颜色" prop="colorId" label-width="60px">
              <el-select filterable v-model="orderInfoForm.colorId" @change="choseColor" placeholder="请选择颜色"
                style="display:block">
                <el-option v-for="(item, index) in colorList" :key="index" :label="item.colorName"
                  :value="item.colorId">{{
                    item.colorName }}</el-option>
              </el-select>
            </el-form-item>
          </li>
          <li>
            <el-form-item label="金额" prop="price">
              <el-input disabled v-model.trim="orderInfoForm.price"></el-input>
            </el-form-item>
          </li>
          <li>
            <el-form-item label="部件渠道" prop="partChannel" label-width="60px">
              <el-select filterable v-model="partChannel" placeholder="请选择部件渠道" clearable>
                <el-option v-for="(item, index) in partChannelList" :label="item.paraName" :value="item.paraCode"
                  :key="index">
                </el-option>
              </el-select>
            </el-form-item>
          </li>
        </ul>
        <div class="dashLine"></div>
        <el-row>
          <el-col :span="24" class="fl clearfix">
            <el-form-item label="故障分类">
              <el-checkbox-group v-model="faultTypeCheckList">
                <el-checkbox v-for="(item, index) in faultTypeList" :key="index" @change="chooseFaultType(item)"
                  :label="item.faultTypesId" name>{{ item.faultTypesName }}</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </el-col>
        </el-row>
        <div class="dashLine"></div>
        <el-row>
          <el-col :span="24" class="fr clearfix">
            <el-form-item label="故障" style="margin-bottom: 0">
              <el-checkbox-group v-model="faultSubCheckList">
                <el-checkbox v-for="(item, index) in faultSubclassList" @change="chooseFaultSubclass(item)" :key="index"
                  :label="item.faultSubclassId" :name="item.faultSubclassId">{{ item.faultSubclassName }}
                  {{ item.price }}元</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </el-col>
        </el-row>
        <div class="dashLine"></div>
        <div v-if="materialList.length > 0">
          <p class="headerT">用料记录</p>
          <el-table :data="materialList" border style="width: 100%">
            <el-table-column prop="materialCode" label="物料编码" align="center"></el-table-column>
            <el-table-column prop="materialName" label="物料名称" align="center"></el-table-column>
            <!-- <el-table-column prop="inboundPrice" align="center" label="成本单价(元)"></el-table-column> -->
            <el-table-column prop="code" align="center" label="序列号(小码)"></el-table-column>
          </el-table>
        </div>
        <div class="dashLine"></div>
        <div>
          <el-form-item label="客服备注" prop="remark">
            <el-input style="width: 100%" v-model.trim="orderInfoForm.handleRemark" placeholder="请输入给派单客服的备注（不超过400字）"
              :maxlength="400" type="text"></el-input>
          </el-form-item>
        </div>
        <!--- 工单回复开始--->
        <div class="dashLine"></div>
        <el-col class="headerT">
          <el-button-group class="clearfix" style="margin-bottom: 20px;width: 100%"
            v-if="orderInfoForm != null && null != orderInfoForm">
            <el-button :class="{ activeBtn: activeBtnIndex === index }" v-for="(item, index) in orderStates"
              @click="changeState(item, index)" :key="index">
              {{ item.name }}
              <span v-if="orderEvents.length !== 0 && index == 1">({{ orderEvents.length }})</span>
              <span v-if="messageList.length !== 0 && index == 0">({{ messageList.length }})</span>
            </el-button>
            <i style="cursor: pointer;" class="el-icon-d-caret fr" @click="toggleSheet()"></i>
          </el-button-group>
          <transition name="el-fade-in-linear">
            <div v-if="isShow" class="clearfix">
              <el-row class="fl" style="width: 50%;  max-height:400px;overflow-x: auto;overflow-y: auto;">
                <el-row customClass="loadingStyle" v-loading="submitMessage" element-loading-text="提交中...">
                  <div class="box-card-content" v-if="activeBtnIndex == 0">
                    <ul class="list">
                      <li v-for="(item, index) in messageList" :key="index">
                        <dl>
                          <dd>
                            <p>
                              {{ item.operatorTypeName }}
                              <span class="title">{{ item.operatorName }}</span>
                              {{ item.createTime | date }}
                            </p>
                            <span class="message">{{ item.message }}</span>
                            <div class="img-content">
                              <img v-if="item.url" v-for="(item, index) in item.pictureList" :key="index"
                                :src="item.url" @click="handlePictureCardPreview(item)" alt />
                            </div>
                          </dd>
                          <dt style="width: 100px;margin-left:20px">
                            <el-button type="danger" size="small" @click="deleteOrderMessage(item.id)">删除回复</el-button>
                          </dt>
                        </dl>
                      </li>
                    </ul>
                    <div class="add-memo-content">
                      <el-form ref="messageForm" :model="messageForm" label-width="100px"
                        :label-position="labelPosition" :rules="messageFormRules">
                        <el-form-item label-width="0" prop="message">
                          <el-input placeholder="请输入回复内容（不超过500字）" :maxlength="500" v-model.trim="messageForm.message"
                            type="textarea"></el-input>
                        </el-form-item>
                        <div class="file-list-content clearfix">
                          <el-upload class="avatar-uploader" list-type="picture-card" ref="upload" :data="postData"
                            action="https://up.qiniup.com" :on-preview="handlePictureCardPreview"
                            :on-remove="handleRemove" :limit="5" :on-exceed="handleExceed"
                            :before-remove="handleBeforeRemove" :accept="acceptImage" :auto-upload="false"
                            :on-success="uploadAvatarSuccess" :on-error="uploadAvatarError"
                            :before-upload="beforeAvatarUpload">
                            <i class="el-icon-plus avatar-uploader-icon"></i>
                          </el-upload>
                          <el-dialog :visible.sync="dialogVisibles">
                            <img width="100%" :src="dialogImageUrl" alt />
                          </el-dialog>
                          <el-button type="primary" @click="createEventFormSubmitBtn('messageForm')"
                            style="margin:0 auto;display: block" size="small">提交</el-button>
                        </div>
                      </el-form>
                    </div>
                  </div>
                  <div v-if="activeBtnIndex == 1">
                    <ul>
                      <li v-for="(item, index) in orderEvents" :key="index" class="eventLi">
                        <span class="createTime childSpan clearfix" v-if="item.createTime">
                          <i class="fl"></i>
                          <span class="fl">{{ formatTime(item.createTime) }}</span>
                          <br />
                        </span>
                        <span class="details childSpan" v-if="item.exentContent">
                          {{ item.exentContent }}
                          <br />
                        </span>
                      </li>
                    </ul>
                  </div>
                </el-row>
              </el-row>

              <el-row class="repair-detail-wrapper fr" style="width: 45%" v-if="imageUrls.length > 0">
                <p class="headerT">维修详情</p>
                <ul class="img-repair">
                  <li v-if="imgBefore.length > 0">
                    <el-image v-for="(item, index) in imgBefore" :key="item" :src="item" :data-img="imageUrls"
                      :preview-src-list="imageUrls" alt></el-image>
                    <p>维修前</p>
                  </li>
                  <li v-if="threeImg.length > 0">
                    <el-image v-for="(item, index) in threeImg" :key="item" :src="item" :data-img="imageUrls"
                      :preview-src-list="imageUrls" alt></el-image>
                    <p>三联单</p>
                  </li>
                </ul>
                <ul class="after-repair clearfix">
                  <li v-if="imgAfter.length > 0" class="fl" v-for="(item, index) in imgAfter" :key="index">
                    <el-image :src="item" :data-img="imageUrls" :preview-src-list="imageUrls" alt></el-image>
                    <p>维修后</p>
                  </li>
                </ul>
              </el-row>
            </div>
          </transition>
        </el-col>
        <div class="clearfix"></div>
        <!--- 工单回复结束--->
        <div class="dashLine"></div>
        <p class="headerT">支付信息</p>
        <el-row>
          <el-col :span="4" style="margin-right:10px">
            <el-form-item label="IMEI" label-width="80px" prop="imei">
              <el-input disabled v-model="orderInfoForm.imei"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4" style="margin-right:10px">
            <el-form-item label-width="80px" label="定金(元)" prop="price">
              <el-input disabled oninput="this.value=this.value.replace(/\D/g,'').replace(/^0{1,}/g,'')" clearable
                placeholder="请输入金额" maxlength="4" v-model="orderInfoForm.earnest"></el-input>
            </el-form-item>
          </el-col>
          <!-- <el-col :span="4" style="margin-right:10px">
            <el-form-item label="折扣" prop="discount">
              <el-select
                v-model="orderInfoForm.discount"
                disabled
                placeholder="请选择折扣"
                style="width: 100%;"
                @change="changeDisCount"
              >
                <el-option label="95折" value="9.5"></el-option>
                <el-option label="9折" value="9"></el-option>
                <el-option label="85折" value="8.5"></el-option>
              </el-select>
            </el-form-item>
          </el-col> -->

          <el-col :span="4" style="margin-right:10px">
            <el-form-item label="合计金额" prop="amountPayable">
              <el-input disabled v-model="orderInfoForm.amountPayable"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4" style="margin-right:10px">
            <el-switch style="display: block;margin-top: 10px;" v-model="orderInfoForm.payFlag" active-color="#13ce66"
              inactive-color="#ff4949" active-text="收款" inactive-text="不收款" :active-value='1' :inactive-value='0'>
            </el-switch>
          </el-col>
          <el-col :span="4" style="margin-right:10px">
            <el-form-item label="实付金额" prop="actualPrice">
              <el-input disabled v-model="orderInfoForm.actualPrice"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4" style="margin-right:10px">
            <el-form-item label="服务SKU" prop="price">
              <el-input disabled v-model="sku"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4" style="margin-right:10px">
            <el-form-item label="支付状态" prop="price">
              <el-input disabled :value="orderInfoForm.payStatus | sysCodeFileter('pay_status')"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4" style="margin-right:10px">
            <el-form-item label="支付方式">
              <el-select disabled v-model="orderInfoForm.paymentId" placeholder="请选择支付方式" style="width: 100%;">
                <el-option v-for="(item, index) in payWay" :key="index"
                  :selected="{ 'selected': item.type == orderInfoForm.paymentId }" :label="item.content"
                  :value="item.type"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="4" style="margin-right:10px">
            <el-form-item label="收钱吧号" prop="takeTheMoney">
              <el-input disabled v-model="orderInfoForm.takeTheMoney"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <el-row>
        <el-col :span="6" style="width: 100%;text-align: center;margin:30px 0 20px">
          <div
            v-if="orderInfoForm.adminStatus == '15' || orderInfoForm.adminStatus == '20' || orderInfoForm.adminStatus == '16'">
            <el-button type="warning" @click="closeBack()">返回</el-button>
          </div>
          <div
            v-if="orderInfoForm.adminStatus == '03' || orderInfoForm.adminStatus == '05' || orderInfoForm.adminStatus == '06' || orderInfoForm.adminStatus == '07' || orderInfoForm.adminStatus == '12' || orderInfoForm.adminStatus == '32' || orderInfoForm.adminStatus == '41' || orderInfoForm.adminStatus == '42' || orderInfoForm.adminStatus == '43' || orderInfoForm.adminStatus == '44'">
            <el-button type="primary" v-if="basicsAuth.cancel_order" @click="cancel()">取消订单</el-button>
            <el-button type="primary" v-if="basicsAuth.change_order_info"
              @click="updateOrder('orderInfoForm')">保存</el-button>
            <el-button type="primary" v-if="basicsAuth.tianxuan_order" @click="jhhToM3Esure()">转单M4</el-button>
            <!-- <el-button type="primary" v-if="basicsAuth.tianxuan_order" @click="tianxuanEsure()" >转单天玄</el-button>
            <el-button type="primary" v-if="basicsAuth.tianxuan_order" @click="jieboEsure()" >转单捷博</el-button> -->
            <el-button type="warning" @click="closeBack()">返回</el-button>
          </div>
          <div
            v-if="orderInfoForm.adminStatus == '09' || orderInfoForm.adminStatus == '13' || orderInfoForm.adminStatus == '36' || orderInfoForm.adminStatus == '17' || orderInfoForm.adminStatus == '10' || orderInfoForm.adminStatus == '14' || orderInfoForm.adminStatus == '33' || orderInfoForm.adminStatus == '37' || orderInfoForm.adminStatus == '11' || orderInfoForm.adminStatus == '34' || orderInfoForm.adminStatus == '38' || orderInfoForm.adminStatus == '08' || orderInfoForm.adminStatus == '31' || orderInfoForm.adminStatus == '35' || orderInfoForm.adminStatus == '39' || orderInfoForm.adminStatus == '40'">
            <el-button type="primary" v-if="basicsAuth.change_order_info"
              @click="updateOrder('orderInfoForm')">保存</el-button>
            <el-button type="primary" v-if="basicsAuth.tianxuan_order" @click="jhhToM3Esure()">转单M4</el-button>
            <!-- <el-button type="primary" v-if="basicsAuth.tianxuan_order" @click="tianxuanEsure()" >转单天玄</el-button>
            <el-button type="primary" v-if="basicsAuth.tianxuan_order" @click="jieboEsure()" >转单捷博</el-button> -->
            <el-button type="warning" @click="closeBack()">返回</el-button>
          </div>
          <div v-if="orderInfoForm.adminStatus == '02'">
            <el-button type="primary" v-if="basicsAuth.change_order_info"
              @click="updateOrder('orderInfoForm')">保存</el-button>
            <el-button type="primary" v-if="basicsAuth.tianxuan_order" @click="jhhToM3Esure()">转单M4</el-button>
            <!-- <el-button type="primary" v-if="basicsAuth.tianxuan_order" @click="tianxuanEsure()" >转单天玄</el-button>
            <el-button type="primary" v-if="basicsAuth.tianxuan_order" @click="jieboEsure()" >转单捷博</el-button> -->
            <el-button type="primary" v-if="basicsAuth.ensure_order" @click="ensure()">确认订单</el-button>
            <el-button type="primary" v-if="basicsAuth.cancel_order" @click="cancel()">取消订单</el-button>
            <el-button type="warning" @click="closeBack()">返回</el-button>
          </div>
          <div v-if="orderInfoForm.adminStatus == '30' || orderInfoForm.adminStatus == '01'">
            <el-button type="primary" v-if="basicsAuth.change_order_info"
              @click="updateOrder('orderInfoForm')">保存</el-button>
            <el-button type="primary" v-if="basicsAuth.ensure_order" @click="ensure()">确认订单</el-button>
            <el-button type="primary" v-if="basicsAuth.unable_to_ensure" @click="notEnsure()">无法确认</el-button>
            <el-button type="primary" v-if="basicsAuth.cancel_order" @click="cancel()">取消订单</el-button>
            <el-button type="warning" @click="closeBack()">返回</el-button>
            <el-button type="primary" v-if="basicsAuth.tianxuan_order" @click="jhhToM3Esure()">转单M4</el-button>
            <!-- <el-button type="primary" v-if="basicsAuth.tianxuan_order" @click="tianxuanEsure()" >转单天玄</el-button>
            <el-button type="primary" v-if="basicsAuth.tianxuan_order" @click="jieboEsure()" >转单捷博</el-button> -->

            <!-- <el-button type="primary" v-if="basicsAuth.ensure_order " >取消天玄</el-button> -->
          </div>
          <div v-if="orderInfoForm.adminStatus == '04'">
            <el-button type="primary" v-if="basicsAuth.change_order_info"
              @click="updateOrder('orderInfoForm')">保存</el-button>
            <el-button type="primary" v-if="basicsAuth.reject" @click="rejectFuc()">驳回订单</el-button>
            <el-button type="primary" v-if="basicsAuth.reassignment" @click="reassignmentFuc()">改派</el-button>
            <el-button type="primary" v-if="basicsAuth.cancel_order" @click="cancel()">取消订单</el-button>
            <el-button type="warning" @click="closeBack()">返回</el-button>
            <!-- <el-button type="primary" v-if="basicsAuth.ensure_order " >转单天玄</el-button> -->
          </div>
        </el-col>
      </el-row>
    </el-col>
    <el-dialog title="请选择送机方式" :visible.sync="dialogFormVisible">
      <el-form>
        <el-form-item label="送机方式" disabled>
          <el-select v-model="sendMachineWay" placeholder="请选择送机方式">
            <el-option v-for="(item, index) in sendMachineWayList" :key="index" :label="item.paraName"
              :value="item.paraValue"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button v-if="sendMachineWay != null && sendMachineWay != ''" type="primary"
          @click="maintenancePendingOpe()">确
          定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="取消原因" :visible.sync="dialogCancelFormVisible" width="400px">
      <el-form :model="cancelForm" ref="cancelForm" :rules="cancelFormRules" :label-position="labelPosition">
        <el-form-item prop="cancelReason" class="select-content" label="取消原因" label-width="80px">
          <el-select filterable style="width: 100%" v-model="cancelForm.cancelReason" placeholder="请选择取消原因">
            <el-option v-for="(item, index) in cancelList" :key="index" :label="item.paraName"
              :value="item.paraValue"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="其他补充" label-width="80px">
          <el-input v-model.trim="cancelForm.cancelDesc" placeholder="请输入取消原因(不超过500字)" maxlength="500" type="textarea"
            auto-complete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" style="text-align:center">
        <el-button @click="emptyCancelConfirm">取 消</el-button>
        <el-button type="primary" @click="cancelConfirmBtn('cancelForm')">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="dialogUnConfirmFormVisible" width="400px">
      <el-form :model="unConfirmForm" ref="unConfirmForm" :rules="unConfirmFormRules" :label-position="labelPosition">
        <el-form-item label="原因" label-width="50px" prop="cannotConfirmDesc">
          <el-input v-model.trim="unConfirmForm.cannotConfirmDesc" placeholder="请输入无法确认原因(不超过500字)" maxlength="500"
            type="textarea" auto-complete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" style="text-align:center">
        <el-button @click="emptyUnConfirm">取 消</el-button>
        <el-button type="primary" @click="unConfirmBtn('unConfirmForm')">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  formatDate,
  formatTime,
  toThousands2,
  handleCopy,
  tabRemove,
  safeGetFirst,
  validatePhone,
  isPositiveInteger
} from "./visitRepairUtils";

import { getPermission } from "../../api/authRequest";

import {
  selectWorkOrderDetails,
  selectWorkOrderIncident,
  changeOrderInfo,
  ensureOrder,
  jhhToM3Order,
  rejectOrder,
  reassignmentOrder,
  unableToEnsure,
  cancelOrder,
  standbyForMaintenance,
  maintenancePending,
  sendOff,
  setOrderTag,
  getOrderMessage,
  addOrderMessage,
  deleteOrderMessage
} from "@/api/order";

import {
  querySysRegion,
  queryColor,
  selectfaultTypes,
  selectFaultSubclass
} from "@/api/system";

import {
  selectParameterInfoBusiness,
  zhselectParameterInfoBusiness,
  selectAllBrand,
  selectCategory,
  selectModel,
  shopList,
  engineerList,
  getQueryMaterial,
  addMaterial
} from "../../api/api";

import { genUpToken } from "../basicSetting/com/qiniuToken.js";

export default {
  name: "visitRepair",
  data() {
    return {
      // 移除未使用的url和srcList
      formSearch: {
        smallCode: ""
      },
      tableData: [], // 表单数据
      allCodeData: [], // 扫码数据存放数组
      dialogVisible: false, // 添加物料弹框状态
      orderTypeStorage: "",
      imgBefore: [],
      imgAfter: [],
      threeImg: [],
      imageUrls: [],
      materialList: [],
      sku: "", // 服务SKU显示
      // 支付方式配置
      payWay: [
        { type: 2, content: "现金" },
        { type: 1, content: "支付宝" },
        { type: 3, content: "微信" },
        { type: 201, content: "支付宝原生" }
      ],
      // 部件渠道配置
      partChannelList: [
        { paraName: '极吼吼', paraCode: 1 },
        { paraName: '全服到家', paraCode: 2 },
        { paraName: '爱回收手艺人', paraCode: 5 },
        { paraName: '金牌手艺人', paraCode: 0 },
        { paraName: '全部', paraCode: '' }
      ],
      channelTypeList: [],
      partChannel: 1,
      isShow: true,
      dialogFormVisible: false,
      sendMachineWay: "",
      loading: false,
      orderId: this.$route.query.orderId,
      orderNo: this.$route.query.orderNo,
      highStar: false,
      content: "",
      orderInfoForm: {
        colorId: "",
        clientBasicInformation: {},
        jOrdersBreakdown: [],
        jOrderServiceEntity: {},
        afterOrder: [],
        handleRemark: ""
      },
      rules: {
        brandId: [
          {
            required: true,
            message: "请选择品牌",
            trigger: "blur"
          }
        ],
        categoryId: [
          {
            required: true,
            message: "请选择品类",
            trigger: "blur"
          }
        ],
        modelId: [
          {
            required: true,
            message: "请选择型号",
            trigger: "blur"
          }
        ],
        // colorId: [
        //   {
        //     required: true,
        //     message: "请选择颜色",
        //     trigger: "blur"
        //   }
        // ],
        engineerId: [
          {
            required: true,
            message: "请选择门店工程师",
            trigger: "blur"
          }
        ]
      },
      mapJson: "../static/json/map.json",
      area: {
        province: {},
        city: {},
        county: {},
        street: {}
      },
      provinceId: "",
      cityId: "",
      countyId: "",
      streetId: "",
      onlyThreeData: false,
      valueTime: "",
      activeBtnIndex: 0,
      orderStates: [{ name: "工单回复" }, { name: "工单事件" }],
      labelPosition: "left",
      returnData: [
        {
          materialCoding: "",
          materialName: "",
          number: "",
          price: "",
          amout: "",
          aogSum: "",
          aogPercentage: "",
          salesReturnSum: "",
          salesReturnPercentage: ""
        }
      ],
      //分页变量
      pages: {
        total: 0,
        page: 1,
        pageSize: 10
      },
      orderTypeList: [],
      sourceForList: [],
      provinceList: [],
      cityList: [],
      countyList: [],
      streetList: [],
      brandList: [], //品牌数组
      categoryList: [], //品类数组
      modelList: [], //型号数组
      colorList: [],
      faultTypeList: [],
      faultSubclassList: [],
      faultTypeCheckList: [],
      faultSubCheckList: [],
      choosedSubclassList: [],
      orderEvents: [],
      orderRemark: [],
      sendMachineWayList: [],
      isTagNow: false,
      labelPosition: "left",
      messageForm: {
        orderId: "",
        message: "",
        picture: ""
      },
      messageFormRules: {
        message: [
          { required: true, message: "请输入回复内容", trigger: "blur" }
        ]
      },
      submitMessage: false,
      messageList: [],
      fileList: [],
      fileKey: [],
      dialogVisibles: false,
      dialogImageUrl: "",
      postData: { token: "", key: "" },
      qiniuaddr: "pic.allscs.cn", // 这是七牛云空间的外链默认域名
      ruleImg: "imageView2/0/q/75|imageslim", //规则
      acceptImage: "image/jpeg,image/jpg,image/png",
      dialogCancelFormVisible: false,
      dialogUnConfirmFormVisible: false,
      cancelForm: {
        id: "",
        cancelReason: "",
        cancelDesc: ""
      },
      cancelFormRules: {
        cancelReason: [
          { required: true, message: "请选择无法确认原因", trigger: "blur" }
        ]
      },
      cancelList: [],
      unConfirmForm: {
        id: "",
        cannotConfirmDesc: ""
      },
      unConfirmFormRules: {
        cannotConfirmDesc: [
          { required: true, message: "请输入取消原因", trigger: "blur" }
        ]
      },
      shopId: "",
      shopDataList: [],
      shopAddress: "",
      engineerDataList: [],
      basicsAuth: {
        reassignment: false,
        cancel_order: false,
        send_off: false,
        standby_for_maintenance: false,
        reject: false,
        change_order_info: false,
        ensure_order: false,
        ensurs_orders: false,
        tianxuan_order: false,
        jiebo_order: false,
        unable_to_ensure: false,
        addMaterials: true,
        queryMaterial: false
      }
    };
  },
  mounted() {
    this.basicsAuth.reassignment = getPermission(
      "/api/workOrder/order/reassignment"
    );
    this.basicsAuth.cancel_order = getPermission(
      "/api/workOrder/order/cancel_order"
    );
    this.basicsAuth.send_off = getPermission("/api/workOrder/order/send_off");
    this.basicsAuth.standby_for_maintenance = getPermission(
      "/api/workOrder/order/standby_for_maintenance"
    );
    this.basicsAuth.reject = getPermission("/api/workOrder/order/reject");
    this.basicsAuth.change_order_info = getPermission(
      "/api/workOrder/order/change_order_info"
    );
    this.basicsAuth.ensure_order = getPermission(
      "/api/workOrder/order/ensure_order"
    );
    this.basicsAuth.tianxuan_order = getPermission(
      "/api/workOrder/order/tianxuan_order"
    );
    this.basicsAuth.jiebo_order = getPermission(
      "/api/workOrder/order/jiebo_order"
    );
    this.basicsAuth.unable_to_ensure = getPermission(
      "/api/workOrder/order/unable_to_ensure"
    );
    this.basicsAuth.change_order_source = getPermission(
      "/api/system/parameterInfoBusiness/selectParameterInfoBusiness"
    );
    this.basicsAuth.addMaterials = getPermission(
      "/api/workOrder/order/replenish_mat"
    );
    this.basicsAuth.queryMaterial = getPermission(
      "/api/inventory/query_lessee_inventory"
    );
    // 权限初始化完成
  },
  created() {
    this.$destroy(); //销毁生命周期
    this.orderTypeStorage = sessionStorage.getItem("orderType");
    var token = "";
    var policy = {};
    var bucketName = "hohofast";
    var AK = "VYiFElH26Am5EbV9T3nACEfNt6xBRz6gEREDFlis";
    var SK = "sFELHoXSwB8NpiWpPj2Wk7theJCO7Iil-2rwSj31";
    var deadline = Math.round(new Date().getTime() / 1000) + 3600;
    policy.scope = bucketName;
    policy.deadline = deadline;
    token = genUpToken(AK, SK, policy);
    this.postData.token = token;

    if (!this.$route.query.orderId) {
      this.orderId = sessionStorage.getItem("saveOrderId");
      this.orderNo = sessionStorage.getItem("saveOrderNo");
    } else {
      this.orderId = this.$route.query.orderId;
      this.orderNo = this.$route.query.orderNo;
    }
    this.queryProvince();
    this.selectWorkOrderDetailsOpe();
    this.getAllOrderType();
    this.getSourceForOpe();
    this.getChannelType();
    this.getBrandList();
    this.getSendMachineWayList();
    this.getOrderMessage();
    this.getOrderCancelList();
    this.getShopList();
    this.getEngineerList();
  },
  computed: {
    //计算属性
    //是否为电商搬单
    isDianShangBanDan() {
      const orderInfoForm = this.orderInfoForm
      return (orderInfoForm.serviceType == 'SM' || orderInfoForm.serviceType == 'DD' || orderInfoForm.serviceType == 'JX') && (orderInfoForm.channelType == 'JDPOP' || orderInfoForm.channelType == 'TB' || orderInfoForm.channelType == 'PDD' || orderInfoForm.channelType == 'DY')
    },
    /**
     * 是否售后
     */
    isAfterSale() {
      return this.orderInfoForm.serviceType == 'SS' || this.orderInfoForm.serviceType == 'DS' || this.orderInfoForm.serviceType == 'QS'
    },
    /**
     * 是否为上门服务（DD或DS类型）
     */
    isDoorService() {
      return this.orderInfoForm.serviceType === "DD" || this.orderInfoForm.serviceType === "DS";
    }
  },
  methods: {
    // 暴露工具函数给模板使用
    formatTime,
    formatDate,
    toThousands2,
    handleCopy,
    //添加物料
    addMaterials() {
      this.dialogVisible = true;
    },
    //弹框 bytyy
    // 添加
    onSubmit() {
      this.getQueryMaterial();
    },
    //删除小码
    deleteRow(index, rows) {
      rows.splice(index, 1);
    },
    // 根据输入小码查询物料
    getQueryMaterial() {
      let params = {
        code: this.formSearch.smallCode
      };
      getQueryMaterial(params)
        .then(res => {
          if (res.data.status == "100") {
            if (res.data.results.length == 0) {
              this.$message({
                message: "查不到数据",
                type: "err"
              });
            } else {
              for (let i = 0; i < res.data.results.length; i++) {
                this.tableData.push(res.data.results[i]);
              }
              let obj = {};
              let formateData = this.tableData.reduce((cur, next) => {
                obj[next.id] ? "" : (obj[next.id] = true && cur.push(next));
                return cur;
              }, []);
              this.tableData = formateData;
            }
          } else {
            this.$message({
              message: res.data.message,
              type: "err"
            });
          }
        })
        .catch(error => {
          this.$Message.error(error.message);
        });
    },

    //添加完小码和之前页面小码一起保存提交
    confimAddMaterial() {
      let newCode = this.tableData.map(item => item.code);
      let oldCode = [];
      if (this.materialList.length == 1) {
        oldCode = this.materialList.map(item => item.code);
      } else if (this.materialList.length > 1) {
        oldCode = this.materialList.map(item => item.code);
      } else {
        oldCode = [];
      }
      this.allCodeData = [...newCode, ...oldCode];
      let params = {
        id: this.orderId,
        maintenanceMaterials: this.allCodeData.join(",")
      };
      addMaterial(params).then(res => {
        if (res.data.status == "100") {
          this.$message({
            message: res.data.message,
            type: "success"
          });
          this.dialogVisible = false;
          this.tableData = [];
          this.formSearch.smallCode = "";
        } else {
          this.$message({
            message: res.data.message,
            type: "err"
          });
        }
      });
    },

    /**
     * 选择门店处理
     * @param {string|number} e - 门店ID
     */
    selectShop(e) {
      const shop = this.shopDataList.find(item => item.id == e);
      if (shop) {
        this.shopAddress = shop.site;
      }
    },
    /**
     * 获取门店工程师列表
     */
    getEngineerList() {
      const params = {
        startRow: 1,
        pageSize: 10000,
        type: "MD",
        state: 1
      };
      engineerList(params)
        .then(res => {
          if (res.data.status == "100") {
            this.engineerDataList = res.data.results.list;
          }
        })
        .catch(error => {
          this.$Message.error(error.message);
        });
    },
    /**
     * 关闭页面返回列表
     */
    closeBack() {
      tabRemove(this.$route.path, this);
      const pathMap = {
        0: "/workOrderManage",
        1: "/workOrderManageRmk"
      };
      const path = pathMap[this.orderTypeStorage] || "/workOrderManageShop";
      this.$router.replace({ path });
    },
    /**
     * 获取门店列表
     */
    getShopList() {
      const params = {
        startRow: 1,
        pageSize: 10000,
        status: 1
      };
      shopList(params)
        .then(res => {
          if (res.data.status == "100") {
            this.shopDataList = res.data.results.list;
          }
        })
        .catch(error => {
          this.$Message.error(error.message);
        });
    },
    //获取订单取消原因列表
    getOrderCancelList() {
      selectParameterInfoBusiness({
        paraType: "order_cancel_reason",
        startRow: 1,
        pageSize: 10000
      })
        .then(res => {
          if (res.data.status == 100) {
            this.cancelList = res.data.results.list;
          }
        })
        .catch(error => {
          this.$Message.error(error.message);
        });
    },
    //获取订单留言列表
    getOrderMessage() {
      getOrderMessage({ orderId: this.orderId })
        .then(res => {
          if (res.data.status == 100) {
            this.messageList = res.data.results;
            this.messageList.forEach((item, index) => {
              item.operatorTypeName =
                item.operatorType == "1" ? "后台人员" : "工程师";
              item.pictureList = [];
              if (item.picture) {
                item.picture.split(",").forEach((item1, index) => {
                  item.pictureList.push({
                    url: item1
                  });
                });
              } else {
                item.pictureList.push({
                  url: item.picture
                });
              }
            });
          }
        })
        .catch(error => {
          this.$Message.error(error.message);
        });
    },
    createEventFormSubmitBtn(formname) {
      this.$refs[formname].validate(valid => {
        if (valid) {
          this.fileList = [];
          this.fileKey = [];
          this.submitMessage = true;
          this.$refs.upload.submit();
          let timer = setTimeout(() => {
            this.addMessageFuc();
          }, 2000);
        } else {
          return false;
        }
      });
    },
    addMessageFuc() {
      let para = {
        orderId: this.orderId,
        message: this.messageForm.message,
        picture: this.fileList.length > 0 ? this.fileList.join(",") : ""
      };
      addOrderMessage(para)
        .then(res => {
          if (res.data.status == 100) {
            this.$message({
              message: "留言成功",
              type: "success"
            });
            this.$refs["messageForm"].resetFields();
            this.$refs.upload.clearFiles();
            this.fileList = [];
            this.fileKey = [];
            this.getOrderMessage();
          } else {
            this.$message({
              message: res.data.message,
              type: "error"
            });
          }
          this.submitMessage = false;
        })
        .catch(error => {
          this.$Message.error(error.message);
        });
    },
    deleteOrderMessage(id) {
      deleteOrderMessage({ id: id })
        .then(res => {
          if (res.data.status == 100) {
            this.$message({
              message: "删除成功",
              type: "success"
            });
            this.getOrderMessage();
          } else {
            this.$message({
              message: res.data.message,
              type: "error"
            });
          }
        })
        .catch(error => {
          this.$Message.error(error.message);
        });
    },
    /**
     * 图片预览处理
     * @param {Object} file - 文件对象
     */
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisibles = true;
    },
    /**
     * 移除文件前确认
     * @param {Object} file - 文件对象
     * @param {Array} fileList - 文件列表
     */
    handleBeforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`);
    },
    /**
     * 移除文件处理
     * @param {Object} file - 文件对象
     * @param {Array} fileList - 文件列表
     */
    handleRemove(file, fileList) {
      this.fileKey.forEach((item, index) => {
        if (item == file.name) {
          this.fileList.splice(index, 1);
          this.fileKey.splice(index, 1);
        }
      });
    },
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制上传 5 张图片，本次选择了 ${files.length
        } 张图片，共选择了 ${files.length + fileList.length} 张图片`
      );
    },
    beforeAvatarUpload(file) {
      const isPNG = file.type === "image/png";
      const isJPG = file.type === "image/jpeg";
      const isLt2M = file.size / 1024 / 1024 < 10;
      if (!isJPG && !isPNG) {
        this.$message.error("上传头像图片只能是 JPG 格式 和Png 格式!");
      }
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 10MB!");
      }
      this.postData.key = file.name;
      return isLt2M;
    },
    /**
     * 图片上传成功处理
     * @param {Object} res - 服务器返回结果
     * @param {Object} file - 文件对象
     */
    uploadAvatarSuccess(res, file) {
      const url = "http://" + this.qiniuaddr + "/" + res.key + "?imageslim";
      if (res.hash) {
        this.fileList.push(url);
        this.fileKey.push(res.key);
      }
    },
    // 富文本图片上传失败
    uploadAvatarError() {
      this.$message.error("图片上传失败，图片名称有冲突，请修改后再上传");
    },

    //切换显示工单
    toggleSheet() {
      this.isShow = !this.isShow;
    },
    //标记
    setOrderTagOpe(order, tag) {
      this.orderInfoForm.isTag = this.orderInfoForm.isTag == 0 ? 1 : 0;
      if (this.isTagNow) {
        this.$message({
          message: "正在处理请稍后！",
          type: "error"
        });
        return;
      }
      this.isTagNow = true;
      let param = {
        orderId: order.id,
        tag: this.orderInfoForm.isTag
      };
      setOrderTag(param)
        .then(res => {
          if (res.data.status == 100) {
            this.isTagNow = false;
            this.$message({
              message: "操作成功",
              type: "success"
            });
          } else {
            this.isTagNow = false;
            this.$message({
              message: "操作失败",
              type: "error"
            });
          }
          this.isTagNow = false;
        })
        .catch(error => {
          this.$Message.error(error.message);
        });
    },
    //入库
    standbyForMaintenanceOpe() {
      this.$confirm("是否确认手机入库, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          let query = {
            id: this.orderInfoForm.id
          };
          standbyForMaintenance(query)
            .then(res => {
              if (res.data.status == "100") {
                this.$message({
                  message: "成功",
                  type: "success"
                });
                this.closeBack();
              } else {
                this.$message({
                  message: "失败",
                  type: "error"
                });
              }
            })
            .catch(error => {
              this.$Message.error(error.message);
            });
        })
        .catch(error => {
          this.$Message.error(error.message);
        });
    },
    //确认送机方式
    maintenancePendingOpe() {
      let query = {
        id: this.orderInfoForm.id,
        sendMachineWay: this.sendMachineWay
      };
      maintenancePending(query)
        .then(res => {
          if (res.data.status == "100") {
            this.$message({
              message: "成功",
              type: "success"
            });
            this.closeBack();
          } else {
            this.$message({
              message: "失败",
              type: "error"
            });
          }
        })
        .catch(error => {
          this.$Message.error(error.message);
        });
    },
    //确认寄出
    sendOffOpe() {
      this.$prompt("请输入快递单号, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消"
      })
        .then(({ value }) => {
          let query = {
            id: this.orderInfoForm.id,
            courierNumber: value
          };
          sendOff(query)
            .then(res => {
              if (res.data.status == "100") {
                this.$message({
                  message: "成功",
                  type: "success"
                });
                this.closeBack();
              } else {
                this.$message({
                  message: "失败",
                  type: "error"
                });
              }
            })
            .catch(error => {
              this.$Message.error(error.message);
            });
        })
        .catch(error => {
          this.$Message.error(error.message);
        });
    },
    //订单信息确认
    ensure() {
      this.$confirm("是否确认订单, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          if (this.provinceId != null || this.cityId != null || this.countyId != null) {
            this.orderInfoForm.provinceName = safeGetFirst(this.provinceList.filter((e) => e.code === this.provinceId), 'name');

            this.orderInfoForm.cityName = safeGetFirst(this.cityList.filter((e) => e.code === this.cityId), 'name');

            this.orderInfoForm.countyName = safeGetFirst(this.countyList.filter((e) => e.code === this.countyId), 'name');

            this.orderInfoForm.streetName = safeGetFirst(this.streetList.filter((e) => e.code === this.streetId), 'name');

            if (this.streetId != null && this.streetList.length > 0) {
              const streetResList = this.streetList.filter((e) => e.code === this.streetId);
              if (streetResList.length > 0) {
                this.orderInfoForm.streetName = streetResList[0].name;
              }
            }
          }

          // console.log(`province: ${JSON.stringify(provinceResList[0].name)} city: ${cityResList[0]} county: ${countyResList[0]}`)

          let submitBool = this.verifySubmit();

          let isEarnest = submitBool == undefined ? true : submitBool.isEarnest;
          if (!isEarnest) {

            let isDD = submitBool.isDD;
            this.orderInfoForm.clientBasicInformation.province = this.provinceId;
            this.orderInfoForm.clientBasicInformation.provinceName = this.orderInfoForm.provinceName;
            this.orderInfoForm.clientBasicInformation.city = this.cityId;
            this.orderInfoForm.clientBasicInformation.cityName = this.orderInfoForm.cityName;
            this.orderInfoForm.clientBasicInformation.county = this.countyId;
            this.orderInfoForm.clientBasicInformation.countyName = this.orderInfoForm.countyName;
            this.orderInfoForm.clientBasicInformation.street = this.streetId;
            this.orderInfoForm.clientBasicInformation.streetName = this.orderInfoForm.streetName;
            this.orderInfoForm.clientBasicInformation.address = isDD
              ? this.shopAddress
              : this.orderInfoForm.clientBasicInformation.address;
            this.loading = true;
            let jOrdersBreakdown = [];
            for (let i = 0; i < this.choosedSubclassList.length; i++) {
              let breakDown = {
                faultSubclassId: this.choosedSubclassList[i].faultSubclassId,
                wasteInfo: "WT",
                price: this.choosedSubclassList[i].price,
                solutionId: this.choosedSubclassList[i].solutionId
              };
              jOrdersBreakdown.push(breakDown);
            }
            let year = "";
            let month = "";
            let date = "";
            debugger;
            if (
              typeof this.orderInfoForm.jOrderServiceEntity.onsiteDate ==
              "string"
            ) {
              let arr = this.orderInfoForm.jOrderServiceEntity.onsiteDate.split(
                "-"
              );
              year = arr[0];
              month = arr[1];
              date = arr[2];
            } else {
              year = this.orderInfoForm.jOrderServiceEntity.onsiteDate.getFullYear();
              month =
                this.orderInfoForm.jOrderServiceEntity.onsiteDate.getMonth() +
                1;
              date = this.orderInfoForm.jOrderServiceEntity.onsiteDate.getDate();
            }
            let starts = this.orderInfoForm.jOrderServiceEntity.onsiteTimeStart.split(
              ":"
            );
            let ends = this.orderInfoForm.jOrderServiceEntity.onsiteTimeEnd.split(
              ":"
            );
            let jOrderServiceEntity = {
              onsiteDate: formatDate(year, month, date),
              onsiteTimeStart: this.orderInfoForm.jOrderServiceEntity
                .onsiteTimeStart,
              onsiteTimeEnd: this.orderInfoForm.jOrderServiceEntity
                .onsiteTimeEnd,
              onsiteTimeStarts: new Date(
                year,
                month - 1,
                date,
                starts[0],
                starts[1],
                "00"
              ),
              onsiteTimeEnds: new Date(
                year,
                month - 1,
                date,
                ends[0],
                ends[1],
                "00"
              ),
              shopId: this.orderInfoForm.jOrderServiceEntity.shopId,
              shopName: this.shopAddress
            };
            this.orderInfoForm.jOrdersBreakdown = jOrdersBreakdown;
            this.orderInfoForm.jOrderServiceEntity = jOrderServiceEntity;
            if (!this.isAfterSale) {
              this.orderInfoForm.originalOrderNo = null;
            }
            ensureOrder(this.orderInfoForm)
              .then(res => {
                this.loading = false;
                if (res.data.status == "100") {
                  this.$message({
                    message: "成功",
                    type: "success"
                  });
                  this.closeBack();
                } else {
                  this.$message({
                    message: "失败",
                    type: "error"
                  });
                }
              })
              .catch(error => {
                this.$Message.error(error.message);
              });
          }
        })
        .catch(error => {
          this.$Message.error(error.message);
        });
    },

    //转单M4系统
    jhhToM3Esure() {
      this.$confirm("转单给M4系统，订单将在M4操作, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.$refs['orderInfoForm'].validate(valid => {
            console.log("validation", valid);
            if (!valid) {
              return false;
            }
            let submitBool = this.verifySubmit();
            let isEarnest = submitBool == undefined ? true : submitBool.isEarnest;
            if (!isEarnest) {
              if (this.orderInfoForm.province != null || this.orderInfoForm.city != null || this.orderInfoForm.county != null) {
                this.orderInfoForm.provinceName = this.provinceList.filter((e) => e.code === this.provinceId)[0].name;
                this.orderInfoForm.cityName = this.cityList.filter((e) => e.code === this.cityId)[0].name;
                this.orderInfoForm.countyName = this.countyList.filter((e) => e.code === this.countyId)[0].name;
                if (this.streetId != null && this.streetList.length > 0) {
                  const streetResList = this.streetList.filter((e) => e.code === this.streetId);
                  if (streetResList.length > 0) {
                    this.orderInfoForm.streetName = streetResList[0].name;
                  }
                }
              }
              this.orderInfoForm.clientBasicInformation.provinceName = this.orderInfoForm.provinceName
              this.orderInfoForm.clientBasicInformation.cityName = this.orderInfoForm.cityName
              this.orderInfoForm.clientBasicInformation.countyName = this.orderInfoForm.countyName
              this.orderInfoForm.clientBasicInformation.streetName = this.orderInfoForm.streetName
              let isDD = submitBool.isDD;
              this.orderInfoForm.clientBasicInformation.province = this.provinceId;
              this.orderInfoForm.clientBasicInformation.city = this.cityId;
              this.orderInfoForm.clientBasicInformation.county = this.countyId;
              this.orderInfoForm.clientBasicInformation.street = this.streetId;
              this.orderInfoForm.clientBasicInformation.address = isDD
                ? this.shopAddress
                : this.orderInfoForm.clientBasicInformation.address;
              this.loading = true;
              let jOrdersBreakdown = [];
              for (let i = 0; i < this.choosedSubclassList.length; i++) {
                let breakDown = {
                  faultSubclassId: this.choosedSubclassList[i].faultSubclassId,
                  wasteInfo: "WT",
                  price: this.choosedSubclassList[i].price,
                  solutionId: this.choosedSubclassList[i].solutionId
                };
                jOrdersBreakdown.push(breakDown);
              }
              let year = "";
              let month = "";
              let date = "";
              debugger;
              if (
                typeof this.orderInfoForm.jOrderServiceEntity.onsiteDate ==
                "string"
              ) {
                let arr = this.orderInfoForm.jOrderServiceEntity.onsiteDate.split(
                  "-"
                );
                year = arr[0];
                month = arr[1];
                date = arr[2];
              } else {
                year = this.orderInfoForm.jOrderServiceEntity.onsiteDate.getFullYear();
                month =
                  this.orderInfoForm.jOrderServiceEntity.onsiteDate.getMonth() +
                  1;
                date = this.orderInfoForm.jOrderServiceEntity.onsiteDate.getDate();
              }
              let starts = this.orderInfoForm.jOrderServiceEntity.onsiteTimeStart.split(
                ":"
              );
              let ends = this.orderInfoForm.jOrderServiceEntity.onsiteTimeEnd.split(
                ":"
              );
              let jOrderServiceEntity = {
                onsiteDate: formatDate(year, month, date),
                onsiteTimeStart: this.orderInfoForm.jOrderServiceEntity
                  .onsiteTimeStart,
                onsiteTimeEnd: this.orderInfoForm.jOrderServiceEntity
                  .onsiteTimeEnd,
                onsiteTimeStarts: new Date(
                  year,
                  month - 1,
                  date,
                  starts[0],
                  starts[1],
                  "00"
                ),
                onsiteTimeEnds: new Date(
                  year,
                  month - 1,
                  date,
                  ends[0],
                  ends[1],
                  "00"
                ),
                shopId: this.orderInfoForm.jOrderServiceEntity.shopId,
                shopName: this.shopAddress
              };
              this.orderInfoForm.jOrdersBreakdown = jOrdersBreakdown;
              this.orderInfoForm.jOrderServiceEntity = jOrderServiceEntity;
              var _self = this;

              if (_self.orderInfoForm.colorId) {
                this.orderInfoForm.colorName = this.colorList.filter(item => {
                  if (item.colorId == _self.orderInfoForm.colorId) {
                    return item;
                  }
                })[0].colorName
              }
              if (!this.isAfterSale) {
                this.orderInfoForm.originalOrderNo = null;
              }

              jhhToM3Order(this.orderInfoForm)
                .then(res => {
                  this.loading = false;
                  if (res.data.status == "100") {
                    this.$message({
                      message: res.data.message,
                      type: "success"
                    });
                    this.closeBack();
                  } else {
                    this.$message({
                      message: res.data.message,
                      type: "error"
                    });
                  }
                })
                .catch(error => {
                  this.$Message.error(error.message);
                });
            }
          });
        })
        .catch(error => {
          this.$Message.error(error.message);
        });
    },

    //驳回
    rejectFuc() {
      this.$confirm("是否确认驳回？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          let submitBool = this.verifySubmit();
          let isEarnest = submitBool == undefined ? true : submitBool.isEarnest;
          if (!isEarnest) {
            if (this.orderInfoForm.province != null || this.orderInfoForm.city != null || this.orderInfoForm.county != null) {
              this.orderInfoForm.provinceName = this.provinceList.filter((e) => e.code === this.provinceId)[0].name;
              this.orderInfoForm.cityName = this.cityList.filter((e) => e.code === this.cityId)[0].name;
              this.orderInfoForm.countyName = this.countyList.filter((e) => e.code === this.countyId)[0].name;
              if (this.streetId != null && this.streetList.length > 0) {
                const streetResList = this.streetList.filter((e) => e.code === this.streetId);
                if (streetResList.length > 0) {
                  this.orderInfoForm.streetName = streetResList[0].name;
                }
              }
            }
            this.orderInfoForm.clientBasicInformation.provinceName = this.orderInfoForm.provinceName
            this.orderInfoForm.clientBasicInformation.cityName = this.orderInfoForm.cityName
            this.orderInfoForm.clientBasicInformation.countyName = this.orderInfoForm.countyName
            this.orderInfoForm.clientBasicInformation.streetName = this.orderInfoForm.streetName
            let isDD = submitBool.isDD;

            this.orderInfoForm.clientBasicInformation.province = this.provinceId;
            this.orderInfoForm.clientBasicInformation.city = this.cityId;
            this.orderInfoForm.clientBasicInformation.county = this.countyId;
            this.orderInfoForm.clientBasicInformation.street = this.streetId;

            this.orderInfoForm.clientBasicInformation.address = isDD
              ? this.shopAddress
              : this.orderInfoForm.clientBasicInformation.address;
            this.loading = true;
            let jOrdersBreakdown = [];
            for (let i = 0; i < this.choosedSubclassList.length; i++) {
              let breakDown = {
                faultSubclassId: this.choosedSubclassList[i].faultSubclassId,
                wasteInfo: "WT",
                price: this.choosedSubclassList[i].price,
                solutionId: this.choosedSubclassList[i].solutionId
              };
              jOrdersBreakdown.push(breakDown);
            }
            let year = "";
            let month = "";
            let date = "";
            if (
              typeof this.orderInfoForm.jOrderServiceEntity.onsiteDate ==
              "string"
            ) {
              let arr = this.orderInfoForm.jOrderServiceEntity.onsiteDate.split(
                "-"
              );
              year = arr[0];
              month = arr[1];
              date = arr[2];
            } else {
              year = this.orderInfoForm.jOrderServiceEntity.onsiteDate.getFullYear();
              month =
                this.orderInfoForm.jOrderServiceEntity.onsiteDate.getMonth() +
                1;
              date = this.orderInfoForm.jOrderServiceEntity.onsiteDate.getDate();
            }
            let starts = this.orderInfoForm.jOrderServiceEntity.onsiteTimeStart.split(
              ":"
            );
            let ends = this.orderInfoForm.jOrderServiceEntity.onsiteTimeEnd.split(
              ":"
            );
            let jOrderServiceEntity = {
              onsiteDate: formatDate(year, month, date),
              onsiteTimeStart: this.orderInfoForm.jOrderServiceEntity
                .onsiteTimeStart,
              onsiteTimeEnd: this.orderInfoForm.jOrderServiceEntity
                .onsiteTimeEnd,
              onsiteTimeStarts: new Date(
                year,
                month - 1,
                date,
                starts[0],
                starts[1],
                "00"
              ),
              onsiteTimeEnds: new Date(
                year,
                month - 1,
                date,
                ends[0],
                ends[1],
                "00"
              ),
              shopId: this.orderInfoForm.jOrderServiceEntity.shopId,
              shopName: this.shopAddress
            };
            this.orderInfoForm.jOrdersBreakdown = jOrdersBreakdown;
            this.orderInfoForm.jOrderServiceEntity = jOrderServiceEntity;
            rejectOrder(this.orderInfoForm)
              .then(res => {
                if (res.data.status == "100") {
                  this.loading = false;
                  this.$message({
                    message: "成功",
                    type: "success"
                  });
                  this.closeBack();
                } else {
                  this.$message({
                    message: "失败",
                    type: "error"
                  });
                }
              })
              .catch(error => {
                this.$Message.error(error.message);
              });
          }
        })
        .catch(error => {
          this.$Message.error(error.message);
        });
    },
    //改派
    reassignmentFuc() {
      this.$confirm("是否确认改派？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          let submitBool = this.verifySubmit();
          let isEarnest = submitBool == undefined ? true : submitBool.isEarnest;
          if (!isEarnest) {
            if (this.orderInfoForm.province != null || this.orderInfoForm.city != null || this.orderInfoForm.county != null) {
              this.orderInfoForm.provinceName = this.provinceList.filter((e) => e.code === this.provinceId)[0].name;
              this.orderInfoForm.cityName = this.cityList.filter((e) => e.code === this.cityId)[0].name;
              this.orderInfoForm.countyName = this.countyList.filter((e) => e.code === this.countyId)[0].name;
              if (this.streetId != null && this.streetList.length > 0) {
                const streetResList = this.streetList.filter((e) => e.code === this.streetId);
                if (streetResList.length > 0) {
                  this.orderInfoForm.streetName = streetResList[0].name;
                }
              }
            }
            this.orderInfoForm.clientBasicInformation.provinceName = this.orderInfoForm.provinceName
            this.orderInfoForm.clientBasicInformation.cityName = this.orderInfoForm.cityName
            this.orderInfoForm.clientBasicInformation.countyName = this.orderInfoForm.countyName
            this.orderInfoForm.clientBasicInformation.streetName = this.orderInfoForm.streetName
            let isDD = submitBool.isDD;
            this.orderInfoForm.clientBasicInformation.province = this.provinceId;
            this.orderInfoForm.clientBasicInformation.city = this.cityId;
            this.orderInfoForm.clientBasicInformation.county = this.countyId;
            this.orderInfoForm.clientBasicInformation.street = this.streetId;

            this.orderInfoForm.clientBasicInformation.address = isDD
              ? this.shopAddress
              : this.orderInfoForm.clientBasicInformation.address;

            this.loading = true;

            let jOrdersBreakdown = [];

            for (let i = 0; i < this.choosedSubclassList.length; i++) {
              let breakDown = {
                faultSubclassId: this.choosedSubclassList[i].faultSubclassId,
                wasteInfo: "WT",
                price: this.choosedSubclassList[i].price,
                solutionId: this.choosedSubclassList[i].solutionId
              };
              jOrdersBreakdown.push(breakDown);
            }
            let year = "";
            let month = "";
            let date = "";
            if (
              typeof this.orderInfoForm.jOrderServiceEntity.onsiteDate ==
              "string"
            ) {
              let arr = this.orderInfoForm.jOrderServiceEntity.onsiteDate.split(
                "-"
              );
              year = arr[0];
              month = arr[1];
              date = arr[2];
            } else {
              year = this.orderInfoForm.jOrderServiceEntity.onsiteDate.getFullYear();
              month =
                this.orderInfoForm.jOrderServiceEntity.onsiteDate.getMonth() +
                1;
              date = this.orderInfoForm.jOrderServiceEntity.onsiteDate.getDate();
            }
            let starts = this.orderInfoForm.jOrderServiceEntity.onsiteTimeStart.split(
              ":"
            );
            let ends = this.orderInfoForm.jOrderServiceEntity.onsiteTimeEnd.split(
              ":"
            );
            let jOrderServiceEntity = {
              onsiteDate: formatDate(year, month, date),
              onsiteTimeStart: this.orderInfoForm.jOrderServiceEntity
                .onsiteTimeStart,
              onsiteTimeEnd: this.orderInfoForm.jOrderServiceEntity
                .onsiteTimeEnd,
              onsiteTimeStarts: new Date(
                year,
                month - 1,
                date,
                starts[0],
                starts[1],
                "00"
              ),
              onsiteTimeEnds: new Date(
                year,
                month - 1,
                date,
                ends[0],
                ends[1],
                "00"
              ),
              shopId: this.orderInfoForm.jOrderServiceEntity.shopId,
              shopName: this.shopAddress
            };
            this.orderInfoForm.jOrdersBreakdown = jOrdersBreakdown;
            this.orderInfoForm.jOrderServiceEntity = jOrderServiceEntity;
            reassignmentOrder(this.orderInfoForm)
              .then(res => {
                this.loading = false;
                if (res.data.status == "100") {
                  this.$message({
                    message: "成功",
                    type: "success"
                  });
                  this.closeBack();
                } else {
                  this.$message({
                    message: "失败",
                    type: "error"
                  });
                }
              })
              .catch(error => {
                this.$Message.error(error.message);
              });
          }
        })
        .catch(error => {
          this.$Message.error(error.message);
        });
    },
    //订单无法确认
    notEnsure() {
      this.$confirm("是否确认订单无法确认, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.dialogUnConfirmFormVisible = true;
        })
        .catch(error => {
          this.$Message.error(error.message);
        });
    },
    //取消订单
    cancel() {
      this.$confirm("是否取消订单, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.dialogCancelFormVisible = true;
        })
        .catch(error => {
          console.log(error);
        });
    },
    //确定取消
    cancelConfirmBtn(formname) {
      this.$refs[formname].validate(valid => {
        if (valid) {
          let query = {
            id: this.orderInfoForm.id,
            cancelReason: this.cancelForm.cancelReason,
            cancelDesc: this.cancelForm.cancelDesc
          };
          cancelOrder(query)
            .then(res => {
              if (res.data.status == "100") {
                this.$message({
                  message: "成功",
                  type: "success"
                });
                this.dialogCancelFormVisible = false;
                this.closeBack();
              } else {
                this.$message({
                  message: res.data.message,
                  type: "error"
                });
              }
            })
            .catch(error => {
              this.$Message.error(error.message);
            });
        } else {
          console.log("验证未通过");
          return false;
        }
      });
    },
    //无法确定
    unConfirmBtn(formname) {
      this.$refs[formname].validate(valid => {
        if (valid) {
          let query = {
            id: this.orderInfoForm.id,
            cannotConfirmDesc: this.unConfirmForm.cannotConfirmDesc
          };
          unableToEnsure(query)
            .then(res => {
              if (res.data.status == "100") {
                this.$message({
                  message: res.data.message,
                  type: "success"
                });
                this.unConfirmForm.cannotConfirmDesc = "";
                this.dialogUnConfirmFormVisible = false;
                this.closeBack();
              } else {
                this.$message({
                  message: res.data.message,
                  type: "error"
                });
              }
            })
            .catch(error => {
              this.$Message.error(error.message);
            });
        } else {
          console.log("验证未通过");
          return false;
        }
      });
    },
    emptyUnConfirm() {
      this.dialogUnConfirmFormVisible = false;
      this.unConfirmForm.cannotConfirmDesc = "";
    },
    emptyCancelConfirm() {
      this.cancelForm.cancelReason = "";
      this.cancelForm.cancelDesc = "";
      this.dialogCancelFormVisible = false;
    },
    //提交前校验
    verifySubmit() {
      let isDD = false;
      let isEarnest = false;
      let submitBool = {};
      isDD = this.isDoorService;
      if (isDD) {
        this.orderInfoForm.province = null;
        this.orderInfoForm.city = null;
        this.orderInfoForm.county = null;
        this.orderInfoForm.street = null;
      } else {
        this.orderInfoForm.province = this.provinceId;
        this.orderInfoForm.city = this.cityId;
        this.orderInfoForm.county = this.countyId;
        this.orderInfoForm.street = this.streetId;
      }
      if (!this.orderInfoForm.orderIdentifier) {
        this.$message({
          message: "请选择订单渠道",
          type: "warning"
        });
        return;
      }
      if (!this.orderInfoForm.jOrderServiceEntity.onsiteDate) {
        this.$message({
          message: "请选择预约时间",
          type: "warning"
        });
        return;
      }
      if (
        (!this.orderInfoForm.jOrderServiceEntity.onsiteTimeStart ||
          !this.orderInfoForm.jOrderServiceEntity.onsiteTimeEnd) &&
        !this.isDoorService
      ) {
        this.$message({
          message: "请选择预约时间",
          type: "warning"
        });
        return;
      }
      if (
        (!this.orderInfoForm.jOrderServiceEntity.onsiteTimeStart ||
          !this.orderInfoForm.jOrderServiceEntity.onsiteTimeEnd) &&
        this.isDoorService
      ) {
        this.orderInfoForm.jOrderServiceEntity.onsiteTimeStart = "09:00";
        this.orderInfoForm.jOrderServiceEntity.onsiteTimeEnd = "22:00";
      }
      if (!this.orderInfoForm.clientBasicInformation.customerName) {
        this.$message({
          message: "请输入客户姓名",
          type: "warning"
        });
        return;
      }
      if (!this.orderInfoForm.clientBasicInformation.telephoneNo) {
        this.$message({
          message: "请输入联系电话",
          type: "warning"
        });
        return;
      }
      if (!validatePhone(this.orderInfoForm.clientBasicInformation.telephoneNo)) {
        this.$message({
          message: "联系电话（手机号码）格式不正确",
          type: "warning"
        });
        return;
      }
      if (!isDD && (!this.provinceId || !this.cityId || !this.countyId)) {
        this.$message({
          message: "请选择省市区",
          type: "warning"
        });
        return;
      }
      // 如果有街道数据但未选择街道，给出提示
      if (!isDD && this.streetList.length > 0 && !this.streetId) {
        this.$message({
          message: "请选择街道",
          type: "warning"
        });
        return;
      }
      if (!this.orderInfoForm.clientBasicInformation.address && !isDD) {
        this.$message({
          message: "请输入详细地址（不超过200字）",
          type: "warning"
        });
        return;
      }
      if (isDD && !this.orderInfoForm.jOrderServiceEntity.shopId) {
        this.$message({
          message: "请选择门店",
          type: "warning"
        });
        return;
      }
      // if(isDD && !this.orderInfoForm.engineerId){
      //     this.$message({
      //         message: "请选择门店工程师",
      //         type: "warning"
      //     });
      //     return
      // }
      if (this.faultSubCheckList.length <= 0) {
        this.$message({
          message: "请选择故障",
          type: "warning"
        });
        return;
      }
      if (this.orderInfoForm.earnest) {
        if (!isPositiveInteger(this.orderInfoForm.earnest)) {
          this.$message({
            message: "定金只能输入数字且不为0",
            type: "warning"
          });
          isEarnest = true;
        } else {
          isEarnest = false;
        }
      }
      return (submitBool = {
        isEarnest: isEarnest,
        isDD: isDD
      });
    },
    //修改订单信息
    updateOrder(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          let submitBool = this.verifySubmit();
          let isEarnest = submitBool == undefined ? true : submitBool.isEarnest;
          if (!isEarnest) {
            if (this.provinceId || this.cityId || this.countyId) {
              this.orderInfoForm.clientBasicInformation.provinceName = safeGetFirst(
                this.provinceList.filter(e => e.code === this.provinceId), 'name'
              );
              this.orderInfoForm.clientBasicInformation.cityName = safeGetFirst(
                this.cityList.filter(e => e.code === this.cityId), 'name'
              );
              this.orderInfoForm.clientBasicInformation.countyName = safeGetFirst(
                this.countyList.filter(e => e.code === this.countyId), 'name'
              );
              // 处理街道信息（如果存在）
              if (this.streetId && this.streetList.length > 0) {
                this.orderInfoForm.clientBasicInformation.streetName = safeGetFirst(
                  this.streetList.filter(e => e.code === this.streetId), 'name'
                );
              }
            }
            let isDD = submitBool.isDD;

            this.orderInfoForm.clientBasicInformation.province = this.provinceId;
            this.orderInfoForm.clientBasicInformation.city = this.cityId;
            this.orderInfoForm.clientBasicInformation.county = this.countyId;
            this.orderInfoForm.clientBasicInformation.street = this.streetId;

            this.orderInfoForm.clientBasicInformation.address = isDD
              ? this.shopAddress
              : this.orderInfoForm.clientBasicInformation.address;

            console.log(this.shopAddress);
            this.loading = true;
            let jOrdersBreakdown = [];
            for (let i = 0; i < this.choosedSubclassList.length; i++) {
              let breakDown = {
                faultSubclassId: this.choosedSubclassList[i].faultSubclassId,
                wasteInfo: "WT",
                price: this.choosedSubclassList[i].price,
                solutionId: this.choosedSubclassList[i].solutionId
              };
              jOrdersBreakdown.push(breakDown);
            }
            let year = "";
            let month = "";
            let date = "";
            if (
              typeof this.orderInfoForm.jOrderServiceEntity.onsiteDate ==
              "string"
            ) {
              let arr = this.orderInfoForm.jOrderServiceEntity.onsiteDate.split(
                "-"
              );
              year = arr[0];
              month = arr[1];
              date = arr[2];
            } else {
              year = this.orderInfoForm.jOrderServiceEntity.onsiteDate.getFullYear();
              month =
                this.orderInfoForm.jOrderServiceEntity.onsiteDate.getMonth() +
                1;
              date = this.orderInfoForm.jOrderServiceEntity.onsiteDate.getDate();
            }
            let starts = this.orderInfoForm.jOrderServiceEntity.onsiteTimeStart.split(
              ":"
            );
            let ends = this.orderInfoForm.jOrderServiceEntity.onsiteTimeEnd.split(
              ":"
            );
            let jOrderServiceEntity = {
              onsiteDate: formatDate(year, month, date),
              onsiteTimeStart: this.orderInfoForm.jOrderServiceEntity
                .onsiteTimeStart,
              onsiteTimeEnd: this.orderInfoForm.jOrderServiceEntity
                .onsiteTimeEnd,
              onsiteTimeStarts: new Date(
                year,
                month - 1,
                date,
                starts[0],
                starts[1],
                "00"
              ),
              onsiteTimeEnds: new Date(
                year,
                month - 1,
                date,
                ends[0],
                ends[1],
                "00"
              ),
              shopId: this.orderInfoForm.jOrderServiceEntity.shopId,
              shopName: this.shopAddress
            };
            this.orderInfoForm.jOrdersBreakdown = jOrdersBreakdown;
            this.orderInfoForm.jOrderServiceEntity = jOrderServiceEntity;

            console.log('this.orderInfoForm', this.orderInfoForm);

            if (this.orderInfoForm.colorId) {
              this.orderInfoForm.colorName = this.colorList.filter(item => {
                if (item.colorId == this.orderInfoForm.colorId) {
                  return item;
                }
              })[0].colorName;
            }
            changeOrderInfo(this.orderInfoForm).then(res => {
              this.loading = false;
              if (res.data.status == "100") {
                this.$message({
                  message: "修改成功",
                  type: "success"
                });
                this.selectWorkOrderDetailsOpe();
                this.closeBack();
              } else {
                this.$message({
                  message: res.data.message,
                  type: "error"
                });
              }
            });
          }
        }
      });
    },
    //获取订单详情
    selectWorkOrderDetailsOpe() {
      let param = {
        orderNo: this.orderNo
      };
      this.loading = true;
      selectWorkOrderDetails(param).then(res => {
        if (res.data.status == "100") {
          this.orderInfoForm = res.data.results;
          console.log(res.data.results.matericalList);
          if (res.data.results.matericalList) {
            this.materialList = res.data.results.matericalList;
          }
          sessionStorage.setItem("saveOrderId", res.data.results.id); //缓存订单ID
          sessionStorage.setItem("saveOrderNo", res.data.results.orderNo); //缓存订单ID
          this.getOrderEvents();
          this.sku = "";
          if (this.orderInfoForm.serveSkuList) {
            if (this.orderInfoForm.serveSkuList.length > 0) {
              this.orderInfoForm.serveSkuList.forEach((item, index) => {
                this.sku += item.serveName + ";";
              });
            }
          }
          this.imgAfter = [];
          this.imageUrls = [];
          this.orderInfoForm.jOrderAfterRepairs.forEach((item, index) => {
            if (item.type == "7") {
              this.threeImg[0] = item.content;
              this.imageUrls.push(item.content);
              console.log(this.imageUrls, "图片预览数组");
              // this.imageUrls[1] = item.content;
            }
            if (item.type == "6") {
              this.imgAfter.push(item.content);
              this.imageUrls.push(item.content);
              // this.imgAfter[0] = item.content
              //this.imageUrls[2] = item.content;
            }
          });
          res.data.results.jOrderBeforeRepairs.forEach((item, index) => {
            if (item.type == "6") {
              this.imgBefore[0] = item.content;
              this.imageUrls.unshift(item.content);
              // this.imageUrls[0] = item.content
            }
          });
          //初始化故障大类，故障小类
          this.faultTypeCheckList = [];
          this.faultSubCheckList = [];
          this.choosedSubclassList = [];
          let set = new Set();
          if (this.orderInfoForm.jOrdersBreakdown) {
            if (this.orderInfoForm.jOrdersBreakdown.length > 0) {
              for (
                let i = 0;
                i < this.orderInfoForm.jOrdersBreakdown.length;
                i++
              ) {
                this.faultSubCheckList.push(
                  this.orderInfoForm.jOrdersBreakdown[i].faultSubclassId
                );
                this.choosedSubclassList.push(
                  this.orderInfoForm.jOrdersBreakdown[i]
                );
                set.add(this.orderInfoForm.jOrdersBreakdown[i].faultTypesId);
              }
            }
            this.faultTypeCheckList = Array.from(set);
          }
          if (null != this.orderInfoForm.clientBasicInformation.province) {
            this.choseProvince(
              this.orderInfoForm.clientBasicInformation.province
            );
          }
          if (null != this.orderInfoForm.clientBasicInformation.city) {
            this.choseCity(this.orderInfoForm.clientBasicInformation.city);
          }
          if (this.orderInfoForm.jOrderServiceEntity.shopName) {
            this.shopAddress = this.orderInfoForm.jOrderServiceEntity.shopName;
          }

          this.provinceId = this.orderInfoForm.clientBasicInformation.province;
          this.cityId = this.orderInfoForm.clientBasicInformation.city;
          this.countyId = this.orderInfoForm.clientBasicInformation.county;
          this.streetId = this.orderInfoForm.clientBasicInformation.street;

          this.brandId = this.orderInfoForm.brandId;

          //获取 品牌  ，品类 ，型号 ， 颜色， 故障大类
          if (null != this.orderInfoForm.brandId) {
            let para = {
              brandId: this.brandId
            };
            selectCategory(para)
              .then(res => {
                if (res.data.status == 100) {
                  this.categoryList = res.data.results;
                } else {
                  this.$message({
                    message: res.data.message,
                    type: "error"
                  });
                }
              })
              .catch(error => {
                this.$Message.error(error.message);
              });
          }
          if (null != this.orderInfoForm.categoryId) {
            let para = {
              brandId: this.orderInfoForm.brandId,
              categoryId: this.orderInfoForm.categoryId
            };
            selectModel(para)
              .then(res => {
                if (res.data.status == 100) {
                  this.modelList = res.data.results;
                  this.selectfaultTypesOpe();
                  this.queryColorOpe();
                } else {
                  this.$message({
                    message: res.data.message,
                    type: "error"
                  });
                }
              })
              .catch(error => {
                this.$Message.error(error.message);
              });
          }
          if (this.orderInfoForm.jOrdersBreakdown != null) {
            let query = {};
            query.faulttypesId = this.orderInfoForm.jOrdersBreakdown[0].faultTypesId;
            query.modelId = this.orderInfoForm.modelId;

            selectFaultSubclass(query).then(res => {
              if (res.data.status == "100") {
                this.faultSubclassList = res.data.results;
              }
            });
          }
          this.loading = false;
        }
        //重复查询省市区
        this.queryCity();
        this.queryCounty();
        // 如果有街道数据，也查询街道
        if (this.countyId != null) {
          this.queryStreet();
        }
      });
    },
    //查看售后订单详情
    gotoService(item) {
      this.$route.query.orderNo = item.orderNo;
      this.orderInfoForm = {
        clientBasicInformation: {},
        jOrdersBreakdown: [],
        jOrderServiceEntity: {},
        afterOrder: []
      };
      this.orderNo = item.orderNo;
      this.selectWorkOrderDetailsOpe();
    },
    //查看原始订单详情
    gotoOrigin(item) {
      this.$route.query.orderNo = item.originalOrderNo;
      this.orderInfoForm = {
        clientBasicInformation: {},
        jOrdersBreakdown: [],
        jOrderServiceEntity: {},
        afterOrder: []
      };
      this.orderNo = item.originalOrderNo;
      this.selectWorkOrderDetailsOpe();
    },


    //刷新
    refresh() {
      this.selectWorkOrderDetailsOpe();
    },
    //切换订单详情与订单事件
    changeState(item, index) {
      this.activeBtnIndex = index;
      //订单事件
      // if(index == 1 && this.orderEvents.length == 0){
      //     this.getOrderEvents()
      // }
      if (index == 1) {
        this.getOrderEvents();
      }
      //订单备注
      if (index == 0 && this.orderRemark.length == 0) {
      }
    },
    //获取订单事件
    getOrderEvents() {
      let query = {
        orderNo: this.orderInfoForm.orderNo
      };
      selectWorkOrderIncident(query).then(res => {
        if (res.data.status == "100") {
          this.orderEvents = res.data.results;
        }
      });
    },
    handleSizeChange(val) {
      this.pages.pageSize = val;
      this.getPurchaseOrdersList();
    },
    handleCurrentChange(Page) {
      this.pages.page = Page;
      this.getPurchaseOrdersList();
    },
    //获取工单类型
    getAllOrderType() {
      selectParameterInfoBusiness({
        startRows: 1,
        pageSize: 100,
        paraType: "order_type"
      }).then(resp => {
        if (resp.data.results) {
          this.orderTypeList = resp.data.results.list;
        }
      });
    },
    // 获取送机方式
    getSendMachineWayList() {
      selectParameterInfoBusiness({
        startRows: 1,
        pageSize: 100,
        paraType: "send_machine_way"
      }).then(resp => {
        if (resp.data.results) {
          this.sendMachineWayList = resp.data.results.list;
        }
      });
    },
    //获取工单渠道来源
    getSourceForOpe() {
      zhselectParameterInfoBusiness({
        startRows: 1,
        pageSize: 100,
        paraType: "order_identifier"
      })
        .then(resp => {
          if (resp.data.results) {
            this.sourceForList = resp.data.results.list;
          }
        })
        .catch(error => {
          this.$Message.error(error.message);
        });
    },

    getChannelType() {
      zhselectParameterInfoBusiness({
        'startRows': 1,
        'pageSize': 100,
        'paraType': 'channel_type'
      }).then(resp => {
        if (resp.data.results) {
          this.channelTypeList = resp.data.results.list
        }
      })
    },
    // 查询省
    queryProvince() {
      let query = {
        parentId: 0
      };

      querySysRegion(query)
        .then(res => {
          if (res.data.status == "100") {
            this.provinceList = res.data.results;
          }
        })
        .catch(error => {
          this.$Message.error(error.message);
        });
    },
    // 查询市
    queryCity() {
      if (!this.provinceId) {
        return;
      }

      let query = {
        parentId: this.provinceId
      };

      querySysRegion(query)
        .then(res => {
          if (res.data.status == "100") {
            this.cityList = res.data.results;
            this.queryCounty();
          }
        })
        .catch(error => {
          this.$Message.error(error.message);
        });
    },
    // 查询区
    queryCounty() {
      if (!this.cityId) {
        return;
      }

      let query = {
        parentId: this.cityId
      };

      querySysRegion(query)
        .then(res => {
          if (res.data.status == "100") {
            this.countyList = res.data.results;
          }
        })
        .catch(error => {
          this.$Message.error(error.message);
        });
    },

    // 查询街道
    queryStreet: function () {
      if (!this.countyId) {
        return;
      }

      let query = {
        parentId: this.countyId
      };

      this.onlyThreeData = false

      querySysRegion(query)
        .then(res => {
          if (res.data.status == "100") {
            this.streetList = res.data.results;

            if (this.streetList.length === 0) {
              this.onlyThreeData = true
            }
          }
        })
        .catch(error => {
          this.$Message.error(error.message);
        });
    },
    // 选省
    choseProvince: function (e) {
      this.cityId = null;
      this.countyId = null;
      this.streetId = null;
      this.cityList = [];
      this.countyList = [];
      this.streetList = [];

      this.queryCity();
    },
    // 选市
    choseCity: function (e) {
      this.countyId = null;
      this.streetId = null;
      this.countyList = [];
      this.streetList = [];

      this.queryCounty();
    },
    // 选区
    choseCounty: function (e) {
      this.streetId = null;
      this.streetList = [];

      this.queryStreet();
    },
    // 选街道
    choseStreet: function (e) {
      // 街道选择逻辑，可以在这里添加相关处理
      console.log('选择的街道:', e);
    },
    //获取机型颜色
    queryColorOpe() {
      let query = {
        modelId: this.orderInfoForm.modelId
      };
      queryColor(query)
        .then(res => {
          if (res.data.status == "100") {
            this.colorList = res.data.results;
            console.log(this.orderInfoForm.colorId);
          }
        })
        .catch(error => {
          this.$Message.error(error.message);
        });
    },
    //机型型号
    getModelList() {
      let para = {
        brandId: this.orderInfoForm.brandId,
        categoryId: this.orderInfoForm.categoryId
      };
      selectModel(para)
        .then(res => {
          if (res.data.status == 100) {
            this.modelList = res.data.results;
          } else {
            this.$message({
              message: res.data.message,
              type: "error"
            });
          }
        })
        .catch(error => {
          this.$Message.error(error.message);
        });
    },
    //机型品类
    getCategoryList() {
      let para = {
        brandId: this.orderInfoForm.brandId
      };
      selectCategory(para)
        .then(res => {
          if (res.data.status == 100) {
            this.categoryList = res.data.results;
          } else {
            this.$message({
              message: res.data.message,
              type: "error"
            });
          }
        })
        .catch(error => {
          this.$Message.error(error.message);
        });
    },
    //机型品牌
    choseBrand(e) {
      this.getCategoryList();
      this.orderInfoForm.categoryId = "";
      this.orderInfoForm.modelId = "";
      this.orderInfoForm.colorId = "";
      this.modelList = [];
      this.colorList = [];
      this.faultTypeList = [];
      this.faultSubclassList = [];
      this.faultTypeCheckList = [];
      this.faultSubCheckList = [];
      this.choosedSubclassList = [];
      this.orderInfoForm.price = 0;
      this.orderInfoForm.amountPayable = 0;
    },
    choseCategory(e) {
      this.getModelList();
      this.orderInfoForm.modelId = "";
      this.orderInfoForm.colorId = "";
      this.colorList = [];
      this.faultSubclassList = [];
      this.faultTypeCheckList = [];
      this.choosedSubclassList = [];
      this.faultSubCheckList = [];
      this.orderInfoForm.price = 0;
      this.orderInfoForm.amountPayable = 0;
    },
    choseModel(e) {
      this.queryColorOpe();
      this.selectfaultTypesOpe();
      this.faultSubclassList = [];
      this.faultTypeCheckList = [];
      this.choosedSubclassList = [];
      this.faultSubCheckList = [];
      this.orderInfoForm.colorId = "";
      this.orderInfoForm.price = 0;
      this.orderInfoForm.amountPayable = 0;
    },
    choseColor(e) {
      // this.faultSubclassList = [];
      // this.faultTypeCheckList = [];
    },
    //获取品牌
    getBrandList() {
      selectAllBrand()
        .then(res => {
          if (res.data.status == 100) {
            this.brandList = res.data.results;
          } else {
            this.$message({
              message: res.data.message,
              type: "error"
            });
          }
        })
        .catch(error => {
          this.$Message.error(error.message);
        });
    },
    //获取故障
    selectfaultTypesOpe() {
      let query = {};
      if (this.orderInfoForm.modelId == null) {
        this.$message({
          message: "请选择型号",
          type: "error"
        });
        return;
      }
      query = {
        modelId: this.orderInfoForm.modelId
      };
      selectfaultTypes(query).then(res => {
        if (res.data.status == "100") {
          this.faultTypeList = res.data.results;
        }
      });
    },
    //选择故障大类
    chooseFaultType(type) {
      let query = {};
      query.faulttypesId = type.faultTypesId;
      query.modelId = this.orderInfoForm.modelId;
      query.partChannel = this.partChannel;
      console.log(query.partChannel, "渠道");
      selectFaultSubclass(query).then(res => {
        if (res.data.status == "100") {
          this.faultSubclassList = res.data.results;
        }
      });
      //计算选中的大类
      var set = new Set();
      for (let i = 0; i < this.choosedSubclassList.length; i++) {
        set.add(this.choosedSubclassList[i].faultTypesId);
      }
      this.faultTypeCheckList = Array.from(set);
    },
    //选择故障小类
    chooseFaultSubclass(subclass) {
      subclass.faultTypesId = subclass.faulttypesId;
      let isHave = false;
      this.faultSubCheckList.forEach((item, index) => {
        if (item == subclass.faultSubclassId) {
          isHave = true;
        }
      });
      if (isHave) {
        let isTrue = false;
        this.choosedSubclassList.forEach((item, index) => {
          if (item.faultTypesId == subclass.faultTypesId) {
            this.faultSubCheckList.splice(index, 1);
          }
        });
        this.faultSubCheckList.forEach((item, index) => {
          if (item == subclass.faultSubclassId) {
            isTrue = true;
          }
        });
        if (!isTrue) {
          this.faultSubCheckList.push(subclass.faultSubclassId);
        }
      } else {
        this.choosedSubclassList.forEach((item, index) => {
          if (item.faultTypesId == subclass.faultTypesId) {
            this.choosedSubclassList.splice(index, 1);
          }
        });
      }
      if (this.faultSubCheckList.length == 0) {
        this.choosedSubclassList = [];
      } else {
        for (let sub = 0; sub < this.faultSubCheckList.length; sub++) {
          if (this.faultSubCheckList[sub] == subclass.faultSubclassId) {
            this.choosedSubclassList.forEach((item, index) => {
              if (item.faultTypesId == subclass.faultTypesId) {
                this.choosedSubclassList.splice(index, 1);
              }
            });
            this.choosedSubclassList.push(subclass);
          }
        }
      }
      this.orderInfoForm.price = 0;
      this.orderInfoForm.amountPayable = 0;
      //计算选中的大类
      var set = new Set();
      for (let i = 0; i < this.choosedSubclassList.length; i++) {
        set.add(this.choosedSubclassList[i].faultTypesId);
        this.orderInfoForm.price += this.choosedSubclassList[i].price;
      }
      if (null != this.orderInfoForm.discount) {
        this.orderInfoForm.amountPayable = (
          this.orderInfoForm.price *
          (this.orderInfoForm.discount / 10)
        ).toFixed(2);
      } else {
        this.orderInfoForm.amountPayable = this.orderInfoForm.price.toFixed(2);
      }
      this.faultTypeCheckList = Array.from(set);
    },
    //选择折扣
    changeDisCount() {
      if (null != this.orderInfoForm.discount) {
        this.orderInfoForm.amountPayable =
          this.orderInfoForm.price * (this.orderInfoForm.discount / 10);
      } else {
        this.orderInfoForm.amountPayable = this.orderInfoForm.price;
      }
    },
  }
};
</script>

<style type="text/css" lang="scss" scoped>
@import "../../assets/css/workOrder.css";
@import './visitRepairUtils/style.scss';
</style>



// WEBPACK FOOTER //
// visitRepair.vue?d5b370e0